import { Checkbox, ITextField, Stack, TextField, useTheme } from "@fluentui/react";
import { debounce } from "lodash";
import React, { useEffect, useMemo, useRef } from "react";


interface IQuickNavSearchControlsProps {
    isHidden: boolean;
    mountOnce: boolean;
    showDifferencesOnly: boolean;
    showDifferencesOnlyDisabled?: boolean;
    onSearch: (query: string) => void;
    onShowDifferencesOnlyChange: (value: boolean) => void;
}

const QuickNavSearchControls: React.FC<IQuickNavSearchControlsProps> = (props) => {
    const {
        isHidden,
        mountOnce,
        onSearch,
        showDifferencesOnly,
        showDifferencesOnlyDisabled,
        onShowDifferencesOnlyChange,
    } = props;
    const theme = useTheme();

    const QUICK_NAV_STICKY_SEARCH_CONTROLS_STYLE = useMemo(() => {
        const style: React.CSSProperties = {
            position: 'sticky',
            top: 0,
            zIndex: 10,
            paddingBottom: 12,
        };
        return style;
    }, [theme]);

    const searchRef = useRef<ITextField | null>(null);

    const setSearchQueryDebounced = useMemo(
        () => {
            return debounce((searchTerm: string) => {
                onSearch(searchTerm);
            }, 300);
        },
        [onSearch]
    );

    // useEffect(() => {
    //     return () => {
    //         setSearchQueryDebounced.cancel();
    //     };
    // }, [setSearchQueryDebounced]);

    useEffect(() => {
        if (!isHidden && mountOnce) {
            // wait for the panel's open animation to settle so its own focus trap doesn't steal focus back
            const timeoutId = window.setTimeout(() => {
                searchRef.current?.focus();
            }, 300);

            return () => window.clearTimeout(timeoutId);
        }

        return undefined;
    }, [isHidden, mountOnce]);

    return (
        <Stack tokens={{ childrenGap: 8 }}
            style={QUICK_NAV_STICKY_SEARCH_CONTROLS_STYLE}
        >
            <TextField
                placeholder="Quick search"
                // value={searchText}
                // onChange={(_, value) => {
                //     const normalizedValue = value ?? '';
                //     setSearchText(normalizedValue);
                //     setSearchQueryDebounced(normalizedValue);
                // }}
                onKeyDown={(event) => {
                    if (event.key !== 'Enter') {
                        return;
                    }

                    setSearchQueryDebounced.cancel();
                    onSearch(searchRef.current?.value ?? '');
                }}
                styles={{
                    root: { width: '90%' },
                }}
                componentRef={searchRef}
            />
            <Checkbox
                label="Show differences only"
                checked={showDifferencesOnly}
                disabled={showDifferencesOnlyDisabled}
                onChange={(_, checked) => onShowDifferencesOnlyChange(checked ?? false)}
            />
        </Stack>
    );
};

export default QuickNavSearchControls;
